import {SET_PAGE, SET_PARENT_PAGE} from "../actions/types";
const initialState = {
    page: '',
    parent_page: ''
};
export default function (state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case SET_PAGE:
            return {
                page: payload,
                parent_page: state.parent_page
            };
        case SET_PARENT_PAGE:
            return {
                page: state.page,
                parent_page: payload
            };
        default:
            return state;
    }
}